import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { HomeIcon, HeartIcon, ActivityIcon, BandageIcon, ArrowRightIcon } from 'lucide-react';
export function ServicesSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const services = [{
    title: 'In-home Care Services',
    desc: 'Professional caregivers providing daily assistance, companionship, and support to help you maintain independence at home.',
    icon: HomeIcon
  }, {
    title: 'Respite & Holiday Care',
    desc: 'Giving family caregivers a well-deserved break while ensuring your loved one receives exceptional care.',
    icon: HeartIcon
  }, {
    title: 'Physical Therapy',
    desc: 'Restoring mobility, strength, and function through personalized rehabilitation programs in your home.',
    icon: ActivityIcon
  }, {
    title: 'Wound Care',
    desc: 'Expert wound assessment, treatment, and management by skilled nursing professionals.',
    icon: BandageIcon
  }];
  return <section id="services" className="py-20 md:py-28 bg-white" data-id="element-313">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-314">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-315">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-316">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-317">
              Our Services
            </h2>
            <div className="w-20 h-1.5 bg-secondary mx-auto mb-6 rounded-full" data-id="element-318"></div>
            <p className="text-lg text-dark-muted" data-id="element-319">
              Comprehensive healthcare solutions tailored to your needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-320">
            {services.map((service, idx) => <div key={idx} className="bg-white rounded-2xl p-8 shadow-card hover:shadow-card-hover border border-gray-100 transition-all duration-300 transform hover:-translate-y-2 group flex flex-col h-full" data-id="element-321">
                <div className="bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary transition-colors duration-300" data-id="element-322">
                  <service.icon className="h-8 w-8 text-primary group-hover:text-white transition-colors duration-300" data-id="element-323" />
                </div>
                <h3 className="text-xl font-bold text-dark mb-4" data-id="element-324">
                  {service.title}
                </h3>
                <p className="text-dark-muted mb-6 flex-grow" data-id="element-325">{service.desc}</p>
                <a href="#/services" className="inline-flex items-center text-primary font-semibold hover:text-primary-dark transition-colors mt-auto" data-id="element-326">
                  Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-327" />
                </a>
              </div>)}
          </div>

          <div className="text-center" data-id="element-328">
            <a href="#/services" className="inline-block bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300 shadow-sm" data-id="element-329">
              View All Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}